import { nethttp } from '../../../httpsnippet-lite/targets/java/nethttp/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * java/nethttp
 */
export const javaNethttp = {
    target: 'java',
    client: 'nethttp',
    title: 'java.net.http',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(nethttp, request);
    },
};
